/**
 * @description: 充值管理路由文件
 * @author: lx
 * @Compile：2023-08-02 14：00
 * @update: lx(2023-08-02 14：00)
 */
export default [
  // 积分兑换记录
  {
    path: '/rexchangeRecords',
    component: resolve => require(['../../pages/pages_ports_v3/pointManage/rexchangeRecords/rexchangeRecords.vue'], resolve),
    name: 'rexchangeRecords',
    title: "积分兑换记录",
    meta: {
      title: "积分兑换记录"
    }
  },
  // 积分设置
  {
    path: '/pointSystem',
    component: resolve => require(['../../pages/pages_ports_v3/pointManage/pointSystem/pointSystem.vue'], resolve),
    name: 'pointSystem',
    title: "积分设置",
    meta: {
      title: "积分设置"
    }
  }
];
